<template>
  <v-dialog v-if="open" v-model="open" max-width="600px">
    <v-card v-if="g">
      <v-card-title>
        <span>{{ title }}</span>
        <v-spacer></v-spacer>
        <v-icon class="c-close" @click="closeDialog">close</v-icon>
      </v-card-title>
      <v-container grid-list-lg text-xs-left>
        <v-layout column wrap>
          <v-flex v-if="dialogMsg" class="c-msg">{{ dialogMsg }}</v-flex>
          <v-flex>
            <div class="c-flex c c-member">
              <div class="c-img c-cover-160">
                <c-img :src="`/cover/g/${g.id}/${g.active_time}/`" />
              </div>

              <div class="c-explain">
                <div class="c-com">
                  <community-chip-s :cid="c.id" :wCss="leTbS ? 'ls' : 'lm'" />
                </div>
                <div class="c-name">{{ g.name }}</div>
                <div class="c-members">
                  <selected-members :cid="g.community_id" :cIcon="false" :memberGroups="members"></selected-members>
                </div>
                <div v-if="hasEditors" class="c-editor-area">
                  <div class="c-editor-title">
                    {{ $T('attributes.editors') }}
                  </div>
                  <div>
                    <selected-members :cid="g.community_id" :cIcon="false" :memberGroups="editors"></selected-members>
                  </div>
                </div>
                <div class="c-icons">
                  <v-tooltip top>
                    <v-btn slot="activator" flat icon color="clr-btn" @click.prevent="onMailClicked">
                      <c-svg t="mail" class="mail"></c-svg>
                    </v-btn>
                    <span>{{ $T('mail.to') }}</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      flat
                      icon
                      color="clr-btn"
                      :loading="chatLoading"
                      @click.prevent="onTalkClicked"
                    >
                      <c-svg t="talk" class="talk"></c-svg>
                    </v-btn>
                    <span>{{ $T('talk.to') }}</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn slot="activator" flat icon color="clr-btn" @click.prevent="onAlbumClicked">
                      <c-svg t="photo" class="photo"></c-svg>
                    </v-btn>
                    <span>{{ $T('page.album.share.picture') }}</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn slot="activator" flat icon color="clr-btn" @click.prevent="openEditEvent = true">
                      <c-svg t="c-calendar" class="c-calendar"></c-svg>
                    </v-btn>
                    <span>{{ $T('page.cal.schedule') }}</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex v-if="errMsg" class="c-errmsg">
            {{ errMsg }}
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-tooltip bottom class="c-btn">
          <v-btn
            slot="activator"
            flat
            icon
            color="clr-black"
            :disabled="!isCreator || deleteLoading"
            :loading="deleteLoading"
            @click.prevent="del"
          >
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
          <span>{{ $T('button.delete') }}</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip bottom class="c-btn">
          <v-btn slot="activator" flat icon color="clr-black" :disabled="deleteLoading" @click.prevent="$refs.editGroupDialog.openEditDialog(g)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <span>{{ $T('common.edit') }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>

    <confirm-dialog ref="confirmDialog" @ok="delConfirmed" @cancel="onConfirmCancel" />

    <edit-group-dialog ref="editGroupDialog" @changed="onChanged" />

    <edit-event-dialog
      v-if="openEditEvent"
      :initCid="g.community_id"
      :members="toGroups"
      :targetMoment="getCurrent()"
      @registered="onEventRegistered"
      @close="openEditEvent = false"
    ></edit-event-dialog>

    <edit-post-menu-list-dialog
      v-model="postDialog"
      :initCid="g ? g.community_id : 0"
      :initMembers="g ? [`g${g.id}`] : null"
    />
  </v-dialog>
</template>

<script>
import { getGroupDetail, deleteGroup } from '../../api/group';
import { createPersonalTalk } from '../../api/communityTalk';
import UTILS from '../../utils/utils';
import talkPlugin from '../../utils/plugin/talkPlugin';
import editEventDialog from '../event/EditEventDialog';
import editGroupDialog from './EditGroupDialog';
import editPostMenuListDialog from '../post/EditPostMenuListDialog';

export default {
  components: {
    'edit-group-dialog': editGroupDialog,
    'edit-event-dialog': editEventDialog,
    'edit-post-menu-list-dialog': editPostMenuListDialog,
  },
  mixins: [talkPlugin],
  data() {
    return {
      open: false,
      openEditEvent: false,
      postDialog: false,
      title: $T('page.member.info.group.info.title'),
      dialogMsg: null,
      errMsg: null,
      g: null,
      members: [],
      editors: [],
      loading: false,
      deleteLoading: false,
      chatLoading: false,
    };
  },
  watch: {},
  computed: {
    c() {
      return this.cMap[this.g.community_id];
    },
    hasEditors() {
      return this.editors && this.editors.length > 0;
    },
    toGroups() {
      return [`g${this.g.id}`];
    },
    isCreator() {
      return this.cidToCmid(this.g.community_id) == this.g.creator_cmid;
    },
  },
  methods: {
    openDialog(g) {
      this.chatLoading = false;
      this.dialogMsg = null;
      this.errMsg = null;
      this.g = g;
      var self = this;
      getGroupDetail(g.id)
        .then(function(response) {
          self.members = response.members;
          self.editors = response.editors;
          self.chatLoading = false;
          self.open = true;
          setTimeout(self.initFocus, 500);
        })
        .catch(function(e) {
          console.error('failed to get data', e);
          self.errGetData();
          self.chatLoading = false;
        });
    },
    closeDialog() {
      this.open = false;
    },
    onTalkClicked() {
      var d = {
        cid: this.g.community_id,
        members: [`m${this.cidToCmid(this.g.community_id)}`, `g${this.g.id}`],
      };
      this.chatLoading = true;
      var self = this;
      createPersonalTalk(setupFormData(d))
        .then(function(response) {
          self.mergeAndMoveToTalk(response.data);
          self.chatLoading = false;
          self.open = false;
        })
        .catch(function(error) {
          console.error(error);
          self.chatLoading = false;
          self.shortMsg($T('common.failed.register'), true);
        });
    },
    onMailClicked() {
      this.postDialog = true;
    },
    onAlbumClicked() {
      this.$store.commit('OPEN_UPLOAD', { cid: this.g.community_id, members: [`g${this.g.id}`] });
    },
    onEventRegistered(d) {
      var toCid = this.getRouteCid();
      if (toCid && this.g.community_id != toCid) toCid = this.g.community_id;
      this.$router.push({ name: 'calendarYm', params: { id: toCid, t: this.$moment(d).format('YYYYMM') } });
    },
    getCurrent() {
      return this.$moment();
    },
    onChanged(g) {
      this.$emit('changed', g);
      this.closeDialog();
    },
    del() {
      this.$refs.confirmDialog.openDialog(
        'del',
        $T('page.member.info.group.delete.title'),
        $T('page.member.info.group.delete.msg'),
        this.gid,
        true
      );
    },
    onConfirmCancel(key, value) {
      this.deleteLoading = false;
    },
    delConfirmed() {
      var gid = this.g.id;
      this.deleteLoading = true;
      var self = this;
      deleteGroup(gid)
        .then(function(response) {
          self.$emit('deleted', response);
          self.deleteLoading = false;
          self.shortMsg($T('page.member.info.group.delete.notify'));
          self.closeDialog();
        })
        .catch(function(e) {
          console.error('failed to delete data', e);
          self.errDeleteData();
          self.deleteLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0px 24px 12px 24px;
}
.le-tbx .container {
  padding: 0px 24px 0 24px;
}
.c-member {
  position: relative;
  margin-top: 5px;
}
.le-tbs .c-img {
  position: absolute;
  width: 100%;
  top: -12px;
  left: 0;
  display: flex;
}
.c-img img {
  margin: 0 auto;
}
.c-explain {
  flex-grow: 1;
  padding-left: 24px;
  width: calc(100% - 164px);
}
.le-tbs .c-explain {
  padding: 170px 0 0 0;
  width: 100%;
}
.c-name {
  text-align: left;
  font-size: 28px;
  padding-bottom: 3px !important;
  color: rgba(0, 0, 0, 0.87);
}
.c-members {
  margin-bottom: 10px;
}
.c-role {
  text-align: left;
  font-size: 16px;
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.54) !important;
}
.c-role.f-danger {
  color: #e64a19 !important;
}
.c-self-mark {
  position: absolute;
  top: -3px;
  left: 117px;
  z-index: 2;
}
.le-tbs .c-self-mark {
  position: absolute;
  top: -14px;
  left: 0;
  width: 100%;
  z-index: 2;
}
.le-tbs .c-self-mark i {
  position: absolute;
  transform: translateX(34px);
  top: 0px;
  left: 50%;
}
.c-self-mark i {
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.6));
}
.c-editor-area {
  margin-bottom: 10px;
}
.c-editor-title {
  color: rgba(0, 0, 0, 0.54);
}
.c-com {
  margin-left: -5px;
}
.c-icons {
  display: flex;
  margin: -8px 0 -8px 0;
}
.le-tbs .c-icons {
  justify-content: center;
}
</style>
